import get from 'lodash/get';
import passport from 'aurora-images/passport.svg';
import nonUAEImage from 'aurora-images/nonUAE-image.png';

export const AUTH_TYPE = {
  BASIC: 'basic',
  EID: 'eid',
  UNIFIED: 'unified',
  UAEPASS: 'uaePass',
  EMAIL: 'email',
};

export const isSignin = (location, exact) => {
  const pathname = get(location, 'pathname');
  if (exact) {
    return pathname === '/' || pathname === '/login';
  }
  return pathname.indexOf('login') > -1;
};

export const identifyPage = location => {
  const pathname = get(location, 'pathname');

  const isUnified = pathname.indexOf(AUTH_TYPE.UNIFIED) > -1;
  const isEid = pathname.indexOf(AUTH_TYPE.EID) > -1;
  const isUaePass = pathname.indexOf(AUTH_TYPE.UAEPASS) > -1;
  const isEmail = pathname.indexOf('nonUae') > -1 || pathname.indexOf('reset-password') > -1;

  if (isUnified) {
    return AUTH_TYPE.UNIFIED;
  }

  if (isEid) {
    return AUTH_TYPE.EID;
  }

  if (isUaePass) {
    return AUTH_TYPE.UAEPASS;
  }

  if (isEmail) {
    return AUTH_TYPE.EMAIL;
  }

  return AUTH_TYPE.BASIC;
};

const mask = {
  unified_number: null,
  emirates_id: [
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
  ],
};

const props = {
  UNIFIED: {
    title: 'Sign in with Unified Number',
    label: 'Unified Number',
    placeholder: '12345',
    mask: mask.unified_number,
  },
  UAE_PASS: {
    title: 'Sign in with UAE pass',
    label: 'UAE pass',
    placeholder: '123-1234-1234567-1',
    mask: mask.emirates_id,
  },
  EID: {
    title: 'Sign in with EID number',
    label: 'EID number',
    placeholder: '123-1234-1234567-1',
    mask: mask.emirates_id,
  },

  EMAIL: {
    title: 'Sign in with Email',
    label: 'Email',
    placeholder: '',
  },
};

const signinProps = {
  UNIFIED: {
    ...props.UNIFIED,
    title: 'Sign in with Unified Number',
  },
  UAE_PASS: {
    ...props.UAE_PASS,
    title: 'Sign in with UAE Pass',
  },
  EID: {
    ...props.EID,
    title: 'Sign in with Emirates ID',
  },
  EMAIL: {
    ...props.EMAIL,
    title: 'Welcome to Dari',
  },
};

export const getImage = location => {
  const page = identifyPage(location);
  switch (page) {
    case AUTH_TYPE.EID:
      return 'https://mobimatterstagingstorage.blob.core.windows.net/operatorportal/Group%201105.png';
    case AUTH_TYPE.UNIFIED:
      return passport;
    case AUTH_TYPE.UAEPASS:
      return 'https://mobimatterstagingstorage.blob.core.windows.net/operatorportal/Group%201105.png';
    case AUTH_TYPE.EMAIL:
      return nonUAEImage;
    default:
      return 'https://mobimatterstagingstorage.blob.core.windows.net/operatorportal/Group%201105.png';
  }
};

export const getConfigs = location => {
  const page = identifyPage(location);

  switch (page) {
    case AUTH_TYPE.EID: {
      if (isSignin(location)) {
        return signinProps.EID;
      }
      return props.EID;
    }
    case AUTH_TYPE.UNIFIED: {
      if (isSignin(location)) {
        return signinProps.UNIFIED;
      }
      return props.UNIFIED;
    }
    case AUTH_TYPE.UAEPASS: {
      if (isSignin(location)) {
        return signinProps.UAE_PASS;
      }
      return props.UAE_PASS;
    }
    case AUTH_TYPE.EMAIL: {
      if (isSignin(location)) {
        return signinProps.EMAIL;
      }
      return props.EMAIL;
    }
    default:
      return {};
  }
};

export const getGrantType = location => {
  const page = identifyPage(location);

  switch (page) {
    case AUTH_TYPE.EID:
      return 'eid';
    case AUTH_TYPE.UNIFIED:
      return 'unifiedNumber';
    case AUTH_TYPE.UAEPASS:
      return 'uaePass';
    case AUTH_TYPE.EMAIL:
      return 'email';
    default:
      return '';
  }
};

export const validatePassword = password => {
  /* eslint-disable prettier/prettier */
  const passwordRegex = /^(?=.*[@$!%*?&#])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
  const isSpecialChar = passwordRegex.test(password);
  if (isSpecialChar) {
    return { is_valid: true };
  }
  return { is_valid: false };
};
